import { standardRequestWithErrorFlash } from 'shared/utils/request';
import { FraudReport, ResolvedReason } from 'fraud/types';

export const fetchFraudReport = async (path: string) => {
  const result = await standardRequestWithErrorFlash.get<{
    fraud_report: FraudReport | null;
  }>(path);

  return result.data.fraud_report;
};

export const fetchFraudResolvedReasons = async (path: string) => {
  const result = await standardRequestWithErrorFlash.get<{
    resolved_reasons: ResolvedReason[];
  }>(path);
  return result.data.resolved_reasons;
};

export const requestFraudReport = async (path: string) => {
  const result = await standardRequestWithErrorFlash.post<{
    fraud_report: FraudReport;
  }>(path);
  return result.data.fraud_report;
};

export const retryFailedFraudReport = async (path: string) => {
  const result = await standardRequestWithErrorFlash.patch<{
    fraud_report: FraudReport;
  }>(path);
  return result.data.fraud_report;
};

export const restoreFraudReport = async (path: string) => {
  const result = await standardRequestWithErrorFlash.post<{
    fraud_report: FraudReport;
  }>(path);
  return result.data.fraud_report;
};

export const resolveFraudReport = async (
  path: string,
  resolved_reason_ids: number[],
  other_text?: string | null
) => {
  const result = await standardRequestWithErrorFlash.post<{
    fraud_report: FraudReport;
  }>(path, {
    resolved_reason_ids,
    other: other_text || null,
  });
  return result.data.fraud_report;
};
